export default "__VITE_ASSET__91ea258e__"